import { Col, Row } from "antd";
import React from "react";
import CodeSyntaxHighlighter from "../../../component/syntax-highlighter";

var lightMode = `
:root {
  --wax-primary-color: #7d70f6;
  --wax-secondary-color: #583d72;
  --wax-warning-color: #fea42d;
  --wax-font-family: Inter, sans-serif;
  --wax-font-size--large: 18px;
  --wax-font-size: 14px;
  --wax-font-size--small: 12px;
  --wax-radius: 12px;
  --wax-radius-small: 4px;
  --wax-radius-card: 16px;
  --wax-border: #DEDEDE;
  --wax-filter-border: #fbfbfb;
  --wax-border-card: rgba(125, 112, 246, 0.32);
  --wax-border-size: 1px;
  --wax-text-color: #4e4e4e;
  --wax-text-color-secondary: #777e90;
  --wax-btn-primary-bg: #fff;
  --wax-btn-primary-border: #cbc6fb;
  --wax-btn-primary--active: #fff;
  --wax-btn-primary-bg--active: #7d70f6;
  --wax-btn-primary-border--active: #7d70f6;
  --wax-bg-list-item: #fbfbfb;
  --wax-bg-inputs: #fff;
  --wax-border-inputs: #00000026;
  --wax-bg-card: #fff;
  --wax-skeleton-bg: #efefef;
  --wax-bg-modal: #fff;
}
`;

var darkMode = `
:root {
  --wax-primary-color: #7d70f6;
 --wax-secondary-color: #583d72;
 --wax-warning-color: #fea42d;
 --wax-font-family: 'Inter', sans-serif;
 --wax-font-size--large: 18px;
 --wax-font-size: 14px;
 --wax-font-size--small: 12px;
 --wax-radius: 12px;
 --wax-radius-small: 4px;
 --wax-radius-card: 16px;
 --wax-border: #4E4E4E;
 --wax-filter-border: #191631;
 --wax-border-card: rgba(125, 112, 246, 0.32);
 --wax-border-size: 1px;
 --wax-text-color: #FFFFFF;
 --wax-text-color-secondary: #CFCFCF;
 --wax-btn-primary-bg: #191631;
 --wax-btn-primary-border: #A49BF9;
 --wax-btn-primary--active: #fff;
 --wax-btn-primary-bg--active: #7d70f6;
 --wax-btn-primary-border--active: #7d70f6;
 --wax-bg-list-item: #191631;
 --wax-bg-inputs: #191631;
 --wax-border-inputs: #A49BF9;
 --wax-bg-card: #191631;
 --wax-skeleton-bg: #33333d;
 --wax-bg-modal: #191631;
}
`;

export default function Theme() {
  return (
    <Row gutter={[0, 24]}>
      <Col xs={24}>
        <h1>Theme</h1>
      </Col>
      <Col xs={24}>
        <Row gutter={[0, 16]}>
          <Col xs={24}>
            <h4 className="w-font-lg fw-600">Light Mode</h4>
          </Col>
          <Col xs={24}>
            <CodeSyntaxHighlighter code={lightMode} />
          </Col>
        </Row>
      </Col>

      <Col xs={24}>
        <Row gutter={[0, 16]}>
          <Col xs={24}>
            <h4 className="w-font-lg fw-600">Dark Mode</h4>
          </Col>
          <Col xs={24}>
            <CodeSyntaxHighlighter code={darkMode} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
